<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure>
                            <i v-if="!resource.picture" class="icon icon-icon_person"></i>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>

                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-file label="Image" v-model="resource.picture_id" width="300"></form-file>

                                <form-text label="Reference" v-model="resource.slug"></form-text>

                                <form-text label="Tracking url" v-model="resource.tracking_url"></form-text>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Name'" v-model="resource.translations[client.id].name"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" :label="'Headline'" v-model="resource.translations[client.id].headline"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-textarea>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import TransporterService from './TransporterService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                resource: {
                },
                options: [],
                isLoading: false
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description']);
                this.initialize()
            },
            beforeUpdate: function(Resource){
                return true;
            },
            getResource: function(){
                return TransporterService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/transporter/Edit.vue